export default __webpack_public_path__ + "images/SK.5fc4661.png";